import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TextField,
  Tooltip,
  Paper,
  Chip,
} from "@mui/material";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import { getDecryptedAccessToken, getDecryptedData } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import LayersIcon from "@mui/icons-material/Layers";

const MyServices = () => {
  const AccessToken = getDecryptedAccessToken();
  const LoginUserDetails = getDecryptedData();
  const [doctorServices, setDoctorServices] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    ApiServices.get(`/apis/default/api/allowedServiceDsicount/${LoginUserDetails.id}`, {
      Authorization: `Bearer ${AccessToken}`,
    }).then((response) => {
      const servicesWithData = response.data || [];
      setDoctorServices(servicesWithData);
    });
  }, [AccessToken]);

  // **Group services by unique service_id**
  const groupedServices = doctorServices.reduce((acc, service) => {
    if (!acc[service.service_id]) {
      acc[service.service_id] = {
        service_id: service.service_id,
        service: service.service,
        unit_cost: service.unit_cost,
        percent_off: service.percent_off,
        subservices: [service.service_subtype],
      };
    } else {
      acc[service.service_id].subservices.push(service.service_subtype);
    }
    return acc;
  }, {});

  const uniqueServices = Object.values(groupedServices);

  // **Filter services by search query**
  const filteredServices = uniqueServices.filter((service) =>
    service.service.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: "bold", textAlign: "center", color: "#028391", mb: 3 }}>
        My Assigned Services
      </Typography>

      {/* Search Filter */}
      <TextField
        label="Search by Service"
        variant="outlined"
        fullWidth
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        sx={{ marginBottom: 2 }}
      />

      {/* If No Services */}
      {filteredServices.length === 0 ? (
        <Typography variant="h6" color="textSecondary" sx={{ textAlign: "center", marginTop: 3 }}>
          No services assigned yet.
        </Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Service ID</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Service</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Unit Cost</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Percent Off</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Subservices</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredServices.map((service) => (
                <TableRow key={service.service_id} sx={{ "&:hover": { backgroundColor: "#f0f8ff" } }}>
                  <TableCell>
                    <LocalHospitalIcon sx={{ color: "#0288d1", verticalAlign: "middle", marginRight: 1 }} />
                    {service.service_id}
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ fontWeight: "bold" }}>{service.service}</Typography>
                  </TableCell>
                  <TableCell>
                    <AttachMoneyIcon sx={{ color: "green", verticalAlign: "middle", marginRight: 1 }} />
                    ${service.unit_cost}
                  </TableCell>
                  <TableCell>
                    <PercentIcon sx={{ color: "purple", verticalAlign: "middle", marginRight: 1 }} />
                    {service.percent_off}%
                  </TableCell>
                  <TableCell>
                    <Tooltip
                      title={
                        <Typography sx={{ fontSize: 14 }}>
                          {service.subservices.join(", ")}
                        </Typography>
                      }
                      arrow
                    >
                      <Chip
                        label={service.subservices.length}
                        color="primary"
                        sx={{
                          cursor: "pointer",
                          fontWeight: "bold",
                          fontSize: 16,
                          padding: "5px 10px",
                        }}
                      />
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default MyServices;
